import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { JustificationsReverseLogistics } from 'contracts/JustificationsReverseLogistics';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_JUSTIFICATIONS_REVERSE_LOGISTICS',
  }
);

export interface ListJustificationsReverseLogisticsState {
  data: JustificationsReverseLogistics[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListJustificationsReverseLogisticsRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: JustificationsReverseLogistics[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListJustificationsReverseLogisticsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListJustificationsReverseLogisticsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListJustificationsReverseLogisticsState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListJustificationsReverseLogisticsState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListJustificationsReverseLogisticsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listJustificationsReverseLogistics = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListJustificationsReverseLogisticsTypes = Types;
export const ListJustificationsReverseLogisticsActions = Creators;
